// extracted by mini-css-extract-plugin
export default {"header":"Header_header__GhBQq","logoWrapper":"Header_logoWrapper__DzaU-","backButtonWrapper":"Header_backButtonWrapper__QeQ4i"};